var app = angular.module('leonardo');

var RestangularConfig = function(RestangularProvider) {

  RestangularProvider.setRequestSuffix('/');

  RestangularProvider.addRequestInterceptor(function (element, operation) {
    if (operation === "remove") {
      return null;
    }
    if (operation === 'get') {
      angular.forEach(element, function (value, key) {
        if (angular.isString(value)) {
          element[key] = encodeURIComponent(value);
        }
      });
    }
    return element;
  });

  RestangularProvider.addFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
    if (operation === 'post') {
      if (!isNull(element.page) && isNull(params.page)) {
        params.page = element.page;
        delete element.page;
      }
    }
    return element;
  });

  RestangularProvider.addResponseInterceptor(function (data, operation) {
    let extractedData;
    if (operation === 'getList') {
      if (data.results) {
        extractedData = data.results;
        extractedData.meta = {
          count: data.count,
          previous: data.previous,
          next: data.next,
          has_pending_audit: data.has_pending_audit
        };
        data = extractedData;
      }
    }
    return data;
  });

};

app.config(['RestangularProvider', RestangularConfig]);
